// Lib
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { getElement } from '../../../../../../../common/elements/utils/elementTraversalUtils';
import { getGroupId } from '../../groups/notificationGroupUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';

// Selectors
import { getElements } from '../../../../../../element/selectors/elementsSelector';

// Components
import BoardTitleSummary from './BoardTitleSummary';

const mapStateToProps = createSelector(
    (state, ownProps) => ownProps.notification,
    (state, ownProps) => ownProps.group,
    getElements,
    (notification, group, elements) => {
        const viewedElements = notification.viewedElements || [];

        const groupId = getGroupId(group);

        const boardTitles = viewedElements.map(({ elementId, boardTitle }) => {
            if (groupId === elementId) return 'This board';

            const element = getElement(elements, elementId);

            return getTitle(element) || boardTitle;
        });

        return {
            boardTitles,
        };
    },
);

export default connect(mapStateToProps)(BoardTitleSummary);
